var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfSouthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600,
    viewBox: "-36 -24 72 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of South Korea") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: -36,
    y: -24,
    width: 72,
    height: 48
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-56.3099325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M-6-25H6M-6-22H6M-6-19H6",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: 44
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1,
    d: "M0,17v10"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#cd2e3a",
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    d: "M0-12A6,6 0 0 0 0,0A6,6 0 0 1 0,12A12,12 0 0,1 0-12Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-123.6900675)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1,
    d: "M0-23.5v3M0,17v3.5M0,23.5v3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfSouthKorea);
export default __webpack_public_path__ + "static/media/flag_of_south_korea.9801985ee1a1b0c2a71b97b25fbd72f1.svg";
export { ForwardRef as ReactComponent };